import { useState } from "react";
import { IoFemale, IoMaleOutline, IoInformationOutline } from "react-icons/io5";
import DescriptionList from "./../../../../../components/common/DescriptionList";
import Modal from "./../../../../../components/common/Modal";
import PersonalForm from "./PersonalForm";
import moment from "moment";

const PersonalInformation = ({ data, isLoading, onRefresh }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const citizenship = data.citizenship ?? "-";
  const civil_status = data.civil_status_type ?? "-";
  const birthplace = data.birthplace ?? "-";
  const middle_name = data.middle_name ?? "";
  const full_name = `${data.last_name}, ${data.first_name} ${middle_name}`;
  const birthdate = data.birthdate ? moment(data.birthdate).format("LL") : "-";

  let gender = "-";

  if (data.gender_type) {
    if (data.gender === 1)
      gender = (
        <div className="flex items-center">
          <span className="mr-2">Male</span>
          <IoMaleOutline className="text-blue-500" />
        </div>
      );

    if (data.gender === 2)
      gender = (
        <div className="flex items-center">
          <span className="mr-2">Female</span>
          <IoFemale className="text-red-300" />
        </div>
      );
  }

  const handleSuccess = () => {
    setShowForm(false);
    onRefresh();
  };

  return (
    <div className="p-5">
      <div className="mt-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IoInformationOutline className="mr-3 text-3xl text-gray-300" />
            <div>
              <p className="text-gray-500">Account Information</p>
              <span className="text-xs text-gray-400">Personal Details</span>
            </div>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
        <div className="px-12 py-5 mt-5 space-y-7">
          <div className="grid grid-cols-2">
            <DescriptionList
              label="Name"
              className="col-span-2 lg:col-span-1"
              content={full_name}
              isLoading={isLoading}
            />
            <DescriptionList
              label="Gender"
              className="col-span-2 lg:col-span-1"
              content={gender}
              isLoading={isLoading}
            />
          </div>
          <div className="grid grid-cols-2">
            <DescriptionList
              label="Civil Status"
              className="col-span-2 lg:col-span-1"
              content={civil_status}
              isLoading={isLoading}
            />
            <DescriptionList
              label="Nationality"
              className="col-span-2 lg:col-span-1"
              content={citizenship}
              isLoading={isLoading}
            />
          </div>
          <div className="grid grid-cols-2">
            <DescriptionList
              label="Date of Birth"
              className="col-span-2 lg:col-span-1"
              content={birthdate}
              isLoading={isLoading}
            />
            <DescriptionList
              label="Place of Birth"
              className="col-span-2 lg:col-span-1"
              content={birthplace}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
      <Modal
        title="Personal Information"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <PersonalForm
          data={data}
          isLoading={isFormLoading}
          setLoading={(value) => setIsFormLoading(value)}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default PersonalInformation;
